import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace LoginApi {
    /**
    * 登录
    */
    export var Login = (body: any): Promise<any> => {
        return Post(`/msls/LoginApi/Login`, body);
    };
    /**
    * 获取验证码
    */
    export var GetCode = (body: any): Promise<any> => {
        return Get(`/msls/LoginApi/GetCode?${qs.stringify(body)}`, {});
    };
    /**
     * 获取权限树
     */
    export var GetPermissionTree = (query: any): Promise<any> => {
        return Get(`/msls/LoginApi/GetPermissionTree?${qs.stringify(query)}`, {});
    };
    /**
     * 编辑权限
     */
    export var EditPermissionTree = (body: any): Promise<any> => {
        return Put(`/msls/LoginApi/EditPermissionTree`, body);
    };
    /**
    * 验证码校验
    */
    export var CheckPhoneCode = (body: any): Promise<any> => {
        return Get(`/msls/LoginApi/CheckPhoneCode?${qs.stringify(body)}`, {});
    };
}
